document.addEventListener('DOMContentLoaded', () => {
  init();
});

const init = async () => {
  document.getElementById('cart__intent--shipping').addEventListener('click', setShipping);
  document.getElementById('cart__intent--pickup').addEventListener('click', setPickup);
  const cartData = await getCart();
  if(cartData.attributes['__Cart Intent']==='Shipping'){
    setShippingActive();
    document.getElementById('checkout').disabled = false;
  }else if(cartData.attributes['__Cart Intent']==='Pickup'){
    setPickupActive();
    document.getElementById('checkout').disabled = false;
  }else{
    document.getElementById('checkout').disabled = true;
  }
};

const setPickup = async (evt) => {
  evt.preventDefault();
  document.getElementById('checkout').disabled = true;
  const variantId = cartProduct.variant;
  const qty = 1;
  let key = '';
  let cartData;
  const cart = await getCart();
    cart.items.forEach(item => {
      if(item.variant_id === variantId){
        key = item.key;
      }
    });
  if(key !== ''){
    cartData = await updateBagItem(key, qty);
  } else {
    cartData = await addBagItem(variantId, qty);
  }
  await setCartMethod('Pickup');
  updateCart(cartData);
  setPickupActive();
  document.getElementById('checkout').disabled = false;
};

const setPickupActive = () => {
  document.getElementById('cart__intent--shipping').classList.remove('active-intent');
  document.getElementById('cart__intent--pickup').classList.add('active-intent');
};

const setShippingActive = () => {
  document.getElementById('cart__intent--shipping').classList.add('active-intent');
  document.getElementById('cart__intent--pickup').classList.remove('active-intent');
};

const setShipping = async (evt) => {
  evt.preventDefault();
  document.getElementById('checkout').disabled = true;
  const variantId = cartProduct.variant;
  const qty = 0;
  let key = '';
  const cart = await getCart();
  cart.items.forEach(item => {
    if(item.variant_id === variantId){
      key = item.key;
    }
  });
  if(key !== ''){
    const data = await updateBagItem(key, qty);
    updateCart(data);
  }
  await setCartMethod('Shipping');
  setShippingActive();
  document.getElementById('checkout').disabled = false;
};

const addBagItem = (variantId, qty) => {
  return fetch('/cart/add.js', {
    method: 'POST',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: qty
        },
      ],
      attributes: {
        '__Cart Intent': 'Pickup'
      },
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    }),
  }).then((response) => response.text()).then(data => data);
};

const updateBagItem = (key, qty) => {
  return fetch('/cart/change.js', {
    method: 'POST',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id:`${key}`,
      quantity:qty,
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    }),
  }).then((response) => response.text()).then(data => data);
};

const setCartMethod = (method) => {
  return fetch('/cart/update.js', {
    method: 'POST',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      attributes:{
        '__Cart Intent': `${method}`
      }
    }),
  }).then((response) => response.text()).then(data => data);
};

const getCart = () => {
  return fetch('/cart.js').then(response => response.json()).then(cart => cart);
};

const updateCart = (state) => {
  const parsedState = JSON.parse(state);

  getSectionsToRender().forEach((section => {
    const elementToReplace = document.getElementById(section.id).querySelector(section.selector) ||
      document.getElementById(section.id);
    elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  }));
};

const getSectionsToRender = () => {
  return [
    {
      id: 'main-cart-items',
      section: document.getElementById('main-cart-items').dataset.id,
      selector: '.js-contents',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section',
    },
    {
      id: 'cart-live-region-text',
      section: 'cart-live-region-text',
      selector: '.shopify-section',
    },
    {
      id: 'main-cart-footer',
      section: document.getElementById('main-cart-footer').dataset.id,
      selector: '.js-contents',
    }
  ];
};

const getSectionInnerHTML = (html, selector) => {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
};

class XsAtc extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('vs:addCart', (cart) => {
      this.updateXs(cart.detail.cart)
    });
  }

  justRenderXs = () => {
    return [
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.xs-contents',
      },
    ];
  };

  getSectionInnerHTML = (html, selector) => {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  };

  updateRegions = (section_html, sections) => {

    sections.forEach((section) => {
      const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
      try {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
            section_html,
            section.selector,
        );
      }catch{
        document.getElementById(section.id).querySelector('.cart__footer--left').innerHTML = this.getSectionInnerHTML(
            section_html,
            '.cart__footer--left',
        );
        document.getElementById(section.id).querySelector('.js-contents').innerHTML = this.getSectionInnerHTML(
            section_html,
            '.js-contents',
        );
        document.querySelector('.cart__blocks cart-note')?.remove();
      }
    });

  };

  updateXs = (parsedState) => {
    const section_id = document.getElementById('main-cart-footer').dataset.id;
    fetch(`/cart?section_id=${section_id}`).
        then(response => response.text()).
        then(response => {
          this.updateRegions(response, this.justRenderXs());
        });
  };

}

customElements.define('xs-section',XsAtc);